import React from "react";
import { Tooltip } from "react-tooltip";

const EasasGlobalTooltip = () => {
  return (
    <>
      <span
        style={{ display: "none", color: "#1d1d1d" }}
        id="simple-tooltip-new"
        className="simple-tooltip"
      />
      <Tooltip id="dween-global-tooltip" className="z-5" />
    </>
  );
};

export default EasasGlobalTooltip;
